import { Stack } from 'expo-router';

export default function ArticlesLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: 'מאמרים | Kursi',
        }}
      />
      <Stack.Screen
        name="[slug]"
        options={{
          title: 'מאמר | Kursi',
        }}
      />
    </Stack>
  );
}
